import { createAction, props } from '@ngrx/store';
import { Filter, TreeNode } from "../models";

export const addSelectedFilter = createAction(
  '[FILTERS] añade un filtro al arreglo de filtros seleccionados',
  props<{ filter: Filter }>()
)

export const setSelectedFilters = createAction(
  '[FILTERS] añade todos los filtros seleccionados',
  props<{ filters: Filter[] }>()
)

export const removeSelectedFilter = createAction(
  '[FILTERS] quita un filtro al arreglo de filtros seleccionados',
  props<{ filter: Filter }>()
)

export const addFilters = createAction(
  '[FILTERS] añade filtros al estado',
  props<{ filters: Filter[] }>()
)

export const deserializeFiltersUrl = createAction(
  '[FILTERS] descompone el parametro de la url para determinar los filtros',
  props<{ query: string, offset: number, limit: number }>()
)

export const loadTreeNodes = createAction(
  '[FILTERS] carga del menu de arbol de filtros',
  props<{ nodes: TreeNode[] }>()
)

export const removeAllFilters = createAction(
  '[FILTERS] remueve todos los filtros del estado'
)
